import { openDialog, WebDialog } from "web-dialog";
import { html, render } from "lit";
import { Media, Ref } from "shared";

export async function openSketchEditor(initialSketch?: Ref<Media>): Promise<Media | undefined> {
	import("../molecules/sketch-editor");
	return await openDialog<WebDialog<Media>>({
		initialize: () => {
			const $d = new WebDialog();
			$d.style.setProperty("--dialog-container-padding", "0");
			$d.style.setProperty("--dialog-padding", "0");
			$d.style.setProperty("--dialog-border-radius", "0");
			$d.style.setProperty("--dialog-max-width", "100vw");
			$d.style.setProperty("--dialog-height", "var(--app-height, 100vh)");
			return $d;
		},
		$content: ($dialog) =>
			render(
				html`
					<div tabindex="0"></div>
					<bs-sketch-editor
						.initialSketch="${initialSketch}"
						@cancel="${() => $dialog.close()}"
						@done="${(e: CustomEvent<Media>) => $dialog.close(e.detail)}"
					></bs-sketch-editor>
				`,
				$dialog
			)
	}).resolver;
}
